/**
 * GA4's recommended `login` event for an existing account that signed in with
 * a code: the same event the apps send, with the same params (catalog entry in
 * `@kiao-voice/core/analytics`).
 *
 * GA4 only, through {@link gaEvent} rather than `trackEvent`: a returning
 * sign-in is not a conversion Meta should optimise toward, and `trackEvent`
 * always sends a Pixel event. The caller decides that the account already
 * existed (`accountWasCreated === false`) and guards capability URLs.
 */
import { gaEvent } from './track'

/** `source`: the surface the sign-in happened on, the same values as `signup_completed`'s. */
export function trackLogin(source: string): void {
  gaEvent('login', { method: 'otp', source })
}
